<template>
  <div class="page__footer">
    <UiDevider class="my-4 hidden sm:block" />
    <h3>Eva & Thomas Buchwald</h3>
    <p>Vintage Collection & Homedeco</p>
    <div class="page__footer-bottom">
      <div class="page__footer-legal">
        <router-link :to="{ name: 'Imprint' }">Imprint</router-link>
        <router-link :to="{ name: 'Data' }">Data-Protection</router-link>
      </div>
      <p>
        © 2020 Eva & Thomas Buchwald Vintage Collection and Home Deco
      </p>
      <p>Website by Tamer Kalieh, Berlin</p>
      <a
        href="https://teamdevmatch.de"
        target="_blank"
        class="page__footer-dev-tag"
        >https://teamdevmatch.de</a
      >
    </div>
    <router-link class="page__footer-auth" :to="{ name: 'Auth' }"
      >Auth</router-link
    >
  </div>
</template>
<script>
export default {}
</script>
<style lang="sass">
.page__footer
    background: $accent-color
    @apply text-white text-center px-4 py-4 relative
    &-bottom
        p
            @apply text-lg
    &-dev-tag
        color: #d57500
        @apply bg-white px-4 my-2 rounded-lg text-xl
    &-legal
        @apply text-white text-center w-full mb-2
        a
            @apply px-2 underline
    &-auth
      @apply absolute bottom-0 right-0 px-2 opacity-0

@screen sm
    .page__footer
        background: $main-bg-color
        &-dev-tag
            @apply text-lg
</style>
